import { render, staticRenderFns } from "./Renewal.vue?vue&type=template&id=31d9e67a&scoped=true&"
import script from "./Renewal.vue?vue&type=script&lang=js&"
export * from "./Renewal.vue?vue&type=script&lang=js&"
import style0 from "./Renewal.vue?vue&type=style&index=0&id=31d9e67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9e67a",
  null
  
)

export default component.exports